/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateEventLogDto,
    CreateEventLogDtoFromJSON,
    CreateEventLogDtoToJSON,
    EventLogDto,
    EventLogDtoFromJSON,
    EventLogDtoToJSON,
} from '../models';

export interface EventLogControllerCreateLogRequest {
    createEventLogDto: CreateEventLogDto;
}

/**
 * 
 */
export class EventLogApi extends runtime.BaseAPI {

    /**
     * Create event log
     */
    async eventLogControllerCreateLogRaw(requestParameters: EventLogControllerCreateLogRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<EventLogDto>> {
        if (requestParameters.createEventLogDto === null || requestParameters.createEventLogDto === undefined) {
            throw new runtime.RequiredError('createEventLogDto','Required parameter requestParameters.createEventLogDto was null or undefined when calling eventLogControllerCreateLog.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/event-logs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEventLogDtoToJSON(requestParameters.createEventLogDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventLogDtoFromJSON(jsonValue));
    }

    /**
     * Create event log
     */
    async eventLogControllerCreateLog(requestParameters: EventLogControllerCreateLogRequest, initOverrides?: RequestInit): Promise<EventLogDto> {
        const response = await this.eventLogControllerCreateLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
